module.exports = __webpack_public_path__ + "static/img/know-right-title.12762ee8.png";